<template>
	<div :class="classNames" :style="{ width: width }">
		<slot name="activator" :onOpen="focusSelect">
            <Button
                class="form-input"
                :disabled="disabled"
				color="secondary"
				style="font-size:16px"
                @blur="blurSelect"
                @focus="focusSelect">
                {{label}} <IconArrowDown v-if="icon"/>
            </Button>
		</slot>
        <slot>
            <div class="menu__list" :class="classList">
                <div class="menu__item_group">Group items</div>
                <div class="menu__item">
                    Item 1
                </div>
                <div class="menu__item">
                    Item 2
                </div>
                <div class="menu__item">
                    Item 3
                </div>
            </div>
        </slot>
	</div>
</template>

<script>
export default {
	name: 'Menu',
	props: {
		modelValue: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		align: {
			type: String,
			default: 'left',
		},
		icon: {
			type: Boolean,
			default: false,
		},
		width: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: 'Menu',
		},
	},
	data() {
		return {
			opened: false,
			focused: false,
		};
	},
	computed: {
		focus() {
			return this.focused && this.modelValue;
		},
        classNames() {
			return {
				menu: true,
				menu_icon: this.icon,
				menu_focus: this.focus,
				menu_opened: this.modelValue,
			};
		},
		classList() {
			return {
				menu__list_align_right: this.align === 'right',
			};
		},
	},
	mounted() {
		// this.focused = !!this.modelValue
		// this.searchString = this.modelValue ? this.modelValue : ''
		document.addEventListener('click', this.handleClickOutside);
	},
	methods: {
		focusSelect(event) {
			event.preventDefault();
			if (this.focused && this.opened) {
				this.focused = false;
				// this.opened = false;
                this.$emit('update:modelValue', false);
			} else {
				this.focused = true;
				// this.opened = true;

				if (event) {
                    this.$emit('update:modelValue', true);
                    this.$emit('focus', event.target.value);
				}
			}
		},
		blurSelect(event) {
			setTimeout(() => {
				this.focused = false;
				// this.opened = false;
                this.$emit('update:modelValue', false);
			}, 100);
		},
		handleClickOutside(evt) {
			if (!this.$el.contains(evt.target)) {
				// this.opened = false;
                this.$emit('update:modelValue', false);
                // this.activeItem = -1
			}
		},
	},
	destroyed() {
		document.removeEventListener('click', this.handleClickOutside);
	},
};
</script>

<style lang="scss">
.menu {
	position: relative;
	display: inline-block;
}
.menu__list {
	position: absolute;
	top: calc(100% + 7px);
	z-index: 1000;
	min-width: 165px;
	max-height: 0;
	padding: 0 20px 3px;
	border: 1px solid $dark-2;
	background: $dark;
	box-shadow: 0 10px 20px rgb(0 0 0 / 20%);
	overflow-y: hidden;
	opacity: 0;
	visibility: hidden;
	transition: opacity 0.3s 0.1s, visibility 0s 0.4s, max-height 0.3s;
	display: flex;
	flex-direction: column;
}
.menu__list_align_right {
	right: 0;
}
.menu__item {
    //position: relative;
    display: flex;
    align-items: center;
    //height: 38px;
    padding: 10px 0;
    font-size: 16px;
    line-height: 16px;
    //transition: background-color 0.3s;
    //cursor: pointer;
}
.menu__item:not(:last-child) {
    border-bottom: 1px solid $neutrals4;
}
//.menu__item:hover {
//    background-color: $primary4;
//}
.menu__item_group {
    padding: 0 15px 5px;
    margin-top: 12px;
    color: var(--colorGray);
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
    text-transform: uppercase;
}

.menu_opened > .menu__list {
	overflow-y: auto;
	max-height: 200px;
	opacity: 1;
	visibility: visible;
	transition: opacity 0.3s, visibility 0s, max-height 0.3s;
}
.menu_opened > .form-input {
	border-color: $primary1;
}
.menu_opened :deep(.arrow),
.menu_opened .menu__container:after {
	transform: rotate(-180deg);
}
</style>
